// import { datadogLogs } from "@datadog/browser-logs";
import { dataDogEnabled } from "./environment-helpers";
var datadogLogs = null;
export var logInfo = function logInfo(message, context) {
  return dataDogEnabled() ? datadogLogs.logger.info(message, context) : void 0;
};
export var logError = function logError(message, context) {
  return dataDogEnabled() ? datadogLogs.logger.error(message, context) : void 0;
};
export var logDebug = function logDebug(message, context) {
  return dataDogEnabled() ? datadogLogs.logger.debug(message, context) : void 0;
};